import React, { useState } from "react";
import { SYSTEM_COLORS, buildWhatsappUrl } from "./constants";
import {
  PreviewStage,
  ModalMock,
  ModalMockHeader,
  ModalMockImage,
  ModalMockPlaceholder,
  ModalMockFooter,
  PreviewButton,
  CarouselWrap,
  NavArrow,
  Dots,
  Dot,
} from "./styles";

// Replica de como o modal vai aparecer no front. Largura real = 470px;
// aqui é representado em escala. Com mais de 1 imagem, vira carrossel.
// A cor do header vem do sistema-alvo (no front real, vem do theme de cada sistema).
function BannerPreview({ images, buttons, systems }) {
  const [index, setIndex] = useState(0);

  const primarySystem = systems && systems[0];
  const headerColor = (primarySystem && SYSTEM_COLORS[primarySystem]) || "#FF2C3A";

  const list = images || [];
  const safeIndex = list.length ? Math.min(index, list.length - 1) : 0;
  const current = list[safeIndex];

  const runAction = (action) => {
    if (!action) return;
    if (action.type === "link" && action.url) window.open(action.url, "_blank");
    else if (action.type === "whatsapp")
      window.open(buildWhatsappUrl(action.phone, action.message), "_blank");
    // 'close' não faz nada no preview
  };

  const go = (dir) =>
    setIndex((safeIndex + dir + list.length) % list.length);

  return (
    <PreviewStage>
      <ModalMock>
        <ModalMockHeader color={headerColor}>
          <span className="logo">Takeat</span>
          <span className="close">✕</span>
        </ModalMockHeader>

        <ModalMockImage clickable={Boolean(current && current.action)}>
          {current && current.url ? (
            <CarouselWrap>
              <img
                src={current.url}
                alt={`Imagem ${safeIndex + 1}`}
                onClick={current.action ? () => runAction(current.action) : undefined}
              />
              {list.length > 1 && (
                <>
                  <NavArrow side="left" onClick={() => go(-1)}>
                    ‹
                  </NavArrow>
                  <NavArrow side="right" onClick={() => go(1)}>
                    ›
                  </NavArrow>
                  <Dots>
                    {list.map((_, i) => (
                      <Dot key={i} active={i === safeIndex} onClick={() => setIndex(i)} />
                    ))}
                  </Dots>
                </>
              )}
            </CarouselWrap>
          ) : (
            <ModalMockPlaceholder>envie uma imagem…</ModalMockPlaceholder>
          )}
        </ModalMockImage>

        {buttons && buttons.length > 0 && (
          <ModalMockFooter $row={buttons.length > 1}>
            {buttons.map((btn, i) => (
              <PreviewButton
                key={i}
                variant={btn.variant}
                color={headerColor}
                $row={buttons.length > 1}
                onClick={() => runAction(btn.action)}
              >
                {btn.label || "Botão"}
              </PreviewButton>
            ))}
          </ModalMockFooter>
        )}
      </ModalMock>
    </PreviewStage>
  );
}

export default BannerPreview;
